var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIconFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#3B7AF6",
    fillOpacity: 0.14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7532 25L18.3239 18.4293L18.7345 18L18.3239 17.5707L11.7532 11L10.8945 11.8587L17.0359 18L10.8945 24.1413L11.7532 25Z",
    fill: "#1E304A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2474 11L17.6768 17.5707L17.2661 18L17.6768 18.4293L24.2474 25L25.1061 24.1413L18.9648 18L25.1061 11.8587L24.2474 11Z",
    fill: "#1E304A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIconFilled);
export default __webpack_public_path__ + "static/media/crossIconFilled.246577f10485b2267fa7d0bca9728b94.svg";
export { ForwardRef as ReactComponent };